import { apiClient } from '~/shared/api/data-ingestion-api'
import { DOCUMENT_SERVER_STATUS } from '../config'
import type { UIDocumentStatusFilter } from './types'

export function getReviewStatus(
  status: UIDocumentStatusFilter[],
): apiClient.ReviewStatusEnum | null {
  if (status.includes('processing')) {
    return DOCUMENT_SERVER_STATUS.processing
  }
  if (status.includes('awaiting')) {
    return DOCUMENT_SERVER_STATUS.pending
  }
  if (status.includes('finished')) {
    return DOCUMENT_SERVER_STATUS.reviewed
  }
  if (status.includes('auto_reviewed')) {
    return DOCUMENT_SERVER_STATUS.auto_reviewed
  }
  return null
}
